import 'reflect-metadata';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

import AuthTypeInitializer from './components/providers/auth-type-initializer';
import StoreProvider from './components/providers/store-provider';
import { ApiProvider } from './components/providers/api-provider';
import ActionsProvider from './components/providers/actions-provider';
import Root from './components/routing/root';
import { LocalStorageProvider } from './components/providers/local-storage-provider';
import './index.less';

import 'ace-builds/webpack-resolver';

const Index = (): JSX.Element => (
  <React.StrictMode>
    <StoreProvider>
      <LocalStorageProvider>
        <AuthTypeInitializer>
          <ApiProvider apiConfig={{ uri: process.env.REACT_APP_API_HOST || '' }}>
            <Router>
              <ActionsProvider>
                <Root />
              </ActionsProvider>
            </Router>
          </ApiProvider>
        </AuthTypeInitializer>
      </LocalStorageProvider>
    </StoreProvider>
  </React.StrictMode>
);

ReactDOM.render(
  <Index />,
  document.getElementById('root'),
);

reportWebVitals();
